import { BoxProps, Flex, Text } from '@chakra-ui/react';

interface BadgeCounterProps extends BoxProps {
  count: number;
}
export const BadgeCounter = ({ count = 0, ...rest }: BadgeCounterProps) => (
  <Flex
    background="B.0"
    justify="center"
    align="center"
    width="fit-content"
    borderRadius="2px"
    borderStyle="solid"
    borderWidth="1px"
    borderColor="M.20"
    {...rest}
  >
    <Text
      align="center"
      as="span"
      color="white"
      fontSize="2xs"
      fontWeight={500}
      minWidth={23}
      px="1"
      py="1px"
    >
      {count}
    </Text>
  </Flex>
);
